module.exports = __webpack_public_path__ + "img/25_f150.2479df38.png";